import { useEffect } from 'react';

interface Props {
  externalUrl: string;
}

export const RedirectToExternal: React.FC<Props> = (props) => {
  const { externalUrl } = props;
  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => window.location.replace(externalUrl), [externalUrl]);
  return null;
};
